module.exports = __webpack_public_path__ + "static/media/kesari_peda.4a35299e.jpg";